import styled from 'styled-components';

export const CenteredContainer = styled.div`
  height: 100%;
  min-height: 100vh;
`;
